/*jshint esversion: 6 */
module.exports = {
    required: value => !!value || 'Required.',
    positiveNumber: value => !value || value >= 0 || 'Invalid number',
    min8: v => !v || v.length >= 8 || 'Min 8 characters',
    min5: v => !v || v.length >= 5 || 'Min 5 characters',
    min1: v => !v || v.length >= 1 || 'Min 1 character',
    max40: v => !v || v.length <= 40 || 'Max 40 character',
    email: value => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value) || 'Your Email is invalid.';
    },
    linkedIn: value => {
      return value.startsWith('https://www.linkedin.com') || value.startsWith('https://linkedin.com') || value === '';
    },
    hasNumber(value) {
      var matches = /\d/.test(value);
      if (matches == true) {
        return true;
      } else {
        return 'password has to contain a number.';
      }
    }
};
